<template>
  <div
    class="p-3 bg-white card multisteps-form__panel border-radius-xl"
    data-animation="FadeIn"
  >
    <h5 class="font-weight-bolder">Finalização</h5>
    <div class="multisteps-form__content">
      <div class="mt-4 button-row d-flex col-12">
        <argon-button
            color="secondary"
            variant="gradient"
            class="mb-0 js-btn-prev"
            title="Prev"
            @click="$parent.prevStep">
              Voltar
          </argon-button>
        <argon-button
          type="button"
          color="dark"
          variant="gradient"
          class="mb-0 ms-auto js-btn-next"
          title="Next"
          :disabled="sincronizar.show"
          @click="$parent.finishStep"
          >Criar Rotas</argon-button
        >
      </div>
      <div class="table-responsive p-0">
        

        <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.text">
            <span class="badge badge-danger badge-lg">
            {{ sincronizar.text }}
            </span>
            
        </div>
        <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.show">

          <div class="d-flex flex-column d-flex align-items-center ">
            
              
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
          </div>

          <div class="progress-wrapper">
              <div class="progress-info">
                <div class="progress-percentage">
                  <span class="text-sm font-weight-bold">{{sincronizar.progress}}%</span>
                </div>
              </div>
              <div class="progress">
                <div 
                  class="bg-primary" 
                  role="progressbar" 
                  :aria-valuenow="sincronizar.progress" 
                  aria-valuemin="0" 
                  aria-valuemax="100" 
                  :style="{ width: sincronizar.progress + '%' }"
                ></div>
              </div>
          </div>

        </div>

      </div>    
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "Finalizacao",
  components: {
    ArgonInput,
    ArgonButton,
  },
  props: {
    sincronizar: {
        type: Object,
        default: () => {
          {};
        },
      },
  }
};
</script>
